__turbopack_context__.v({
  "actionsCell": "WidgetChrome-module__RoMb0W__actionsCell",
  "bezel": "WidgetChrome-module__RoMb0W__bezel",
  "bezelExtra": "WidgetChrome-module__RoMb0W__bezelExtra",
  "body": "WidgetChrome-module__RoMb0W__body",
  "bodyPrimary": "WidgetChrome-module__RoMb0W__bodyPrimary",
  "cellNum": "WidgetChrome-module__RoMb0W__cellNum",
  "cellPnl": "WidgetChrome-module__RoMb0W__cellPnl",
  "cellSymbol": "WidgetChrome-module__RoMb0W__cellSymbol",
  "chip": "WidgetChrome-module__RoMb0W__chip",
  "chipBuy": "WidgetChrome-module__RoMb0W__chipBuy",
  "chipDefault": "WidgetChrome-module__RoMb0W__chipDefault",
  "chipFilled": "WidgetChrome-module__RoMb0W__chipFilled",
  "chipOpen": "WidgetChrome-module__RoMb0W__chipOpen",
  "chipPending": "WidgetChrome-module__RoMb0W__chipPending",
  "chipSell": "WidgetChrome-module__RoMb0W__chipSell",
  "chipWarn": "WidgetChrome-module__RoMb0W__chipWarn",
  "cta": "WidgetChrome-module__RoMb0W__cta",
  "ctaGhost": "WidgetChrome-module__RoMb0W__ctaGhost",
  "deltaDown": "WidgetChrome-module__RoMb0W__deltaDown",
  "deltaUp": "WidgetChrome-module__RoMb0W__deltaUp",
  "label": "WidgetChrome-module__RoMb0W__label",
  "mark": "WidgetChrome-module__RoMb0W__mark",
  "meta": "WidgetChrome-module__RoMb0W__meta",
  "mono": "WidgetChrome-module__RoMb0W__mono",
  "muted": "WidgetChrome-module__RoMb0W__muted",
  "pending": "WidgetChrome-module__RoMb0W__pending",
  "rowAction": "WidgetChrome-module__RoMb0W__rowAction",
  "tableWrap": "WidgetChrome-module__RoMb0W__tableWrap",
  "tabular": "WidgetChrome-module__RoMb0W__tabular",
  "value": "WidgetChrome-module__RoMb0W__value",
  "valueEmpty": "WidgetChrome-module__RoMb0W__valueEmpty",
  "widget": "WidgetChrome-module__RoMb0W__widget",
  "widgetPrimary": "WidgetChrome-module__RoMb0W__widgetPrimary",
});
